<template>
    <div>
        <v-row>
            <v-card
                    class="full-bck fullInfoInner "
                    width="880"
            >
                <div class="scroll ml-10">
                <v-card-text>
                    <div class="full-heading mt-1"> Activity Log</div>
                    <div v-if="activities.length===0">
                        <h5 class="no-data"> No Activity Available</h5>
                    </div>

                    <div v-for="activity in activities" :key="activity._id" class="act-date-div">

                        <div>
                            <p class="time-label">{{activity.date}}</p>

                            <p class="active-label">{{activity.activity[0]}}</p>

                        </div>
                    </div>

                </v-card-text>
    </div>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ActivityLog",
        data(){
            return{
                activities:[],
            }
        },
        methods: {

            getActivities() {
                let activitiesData = this.$store.getters.applicant.activityLog.userActivities
              console.log(activitiesData)
                Object.keys(activitiesData).forEach((value, index) => {
                    this.activities[index] = {date: value, activity: activitiesData[value]};

                })

            }
        },
        mounted() {

        },
        computed: mapGetters([
            'applicant'
        ]),
        created() {
            this.getActivities();


        }

    }
</script>

<style scoped>
    .full-bck{
        background: #FFF2C7;
        border-radius: 16px;
        /*margin-left: 40px !important;*/
    }
    .full-heading{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 21px;
        line-height: 27px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #960C0C;
        margin-bottom: 40px !important;
      margin-top: 30px !important;
    }
    p{
        margin-bottom: 7px !important;
    }
    .active-label{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 23px;

        color: #960C0C;


    }
    .act-date-div{
      margin-bottom: 40px;
    }
    div.col{
        padding: 5px !important;
    }

    .time-label{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;

        color: #00A998;
    }
    .full-info{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        margin-left: 7px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;
        color: #2B1C1C;


    }
    .scroll{
        overflow-y: scroll;
        max-height: 430px;
        height: 430px;
        overflow-x: hidden;
        margin-right: 40px;
        width: 95%;
    }
    .no-data{
        text-align: center !important;
        margin-top: 90px !important;
        color: #960C0C;
    }


</style>